import { LogOut, User } from "lucide-react";
import { Avatar, AvatarFallback } from "@/components/ui/avatar";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { useSilentAuth } from "@/hooks/useAuth";
import { useSidebarStore } from "@/stores/sidebarStore";
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';

export function UserNav() {
  const { user, signOut } = useSilentAuth();
  const navigate = useNavigate();
  const { isOpen } = useSidebarStore();
  
  const firstName = user?.email?.split('@')[0] || 'User';
  const initials = firstName.slice(0, 2).toUpperCase();

  const handleLogout = async () => {
    await signOut();
    
    navigate('/login');
    
    toast.success('You have been logged out of your account');
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" className="w-full justify-start gap-2 px-2">
          <Avatar className="h-8 w-8">
            <AvatarFallback>{initials}</AvatarFallback>
          </Avatar>
          {isOpen && (
            <span className="text-sm font-medium">{firstName}</span>
          )}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-56">
        <DropdownMenuLabel>My Account</DropdownMenuLabel>
        <DropdownMenuSeparator />
        <DropdownMenuItem onClick={() => navigate('/account')}>
          <User className="mr-2 h-4 w-4" />
          <span>Account Settings</span>
        </DropdownMenuItem>
        <DropdownMenuItem onClick={handleLogout}>
          <LogOut className="mr-2 h-4 w-4" />
          <span>Log out</span>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
} 